<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="fi_16791983">
      <path
        id="Vector"
        d="M11.5835 6.91658H8.08349V3.41659C8.08349 3.26188 8.02204 3.1135 7.91264 3.00411C7.80324 2.89471 7.65487 2.83325 7.50016 2.83325C7.34545 2.83325 7.19708 2.89471 7.08768 3.00411C6.97829 3.1135 6.91683 3.26188 6.91683 3.41659V6.91658H3.41683C3.26212 6.91658 3.11375 6.97804 3.00435 7.08744C2.89495 7.19683 2.8335 7.34521 2.8335 7.49992C2.8335 7.65463 2.89495 7.803 3.00435 7.9124C3.11375 8.02179 3.26212 8.08325 3.41683 8.08325H6.91683V11.5832C6.91683 11.738 6.97829 11.8863 7.08768 11.9957C7.19708 12.1051 7.34545 12.1666 7.50016 12.1666C7.65487 12.1666 7.80324 12.1051 7.91264 11.9957C8.02204 11.8863 8.08349 11.738 8.08349 11.5832V8.08325H11.5835C11.7382 8.08325 11.8866 8.02179 11.996 7.9124C12.1054 7.803 12.1668 7.65463 12.1668 7.49992C12.1668 7.34521 12.1054 7.19683 11.996 7.08744C11.8866 6.97804 11.7382 6.91658 11.5835 6.91658Z"
        fill="#434343"
      />
    </g>
  </svg>
</template>
